import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "risk-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nr_tag = _resolveComponent("nr-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_ctx.reviewStatus)
      ? (_openBlock(), _createBlock(_component_nr_tag, {
          key: 0,
          label: _ctx.statusText,
          "tag-color": _ctx.statusColor,
          clickable: _ctx.manage,
          iconPosition: _ctx.iconPosition,
          icon: _ctx.icon,
          onOnClick: _ctx.handleOnReviewClick
        }, null, 8, ["label", "tag-color", "clickable", "iconPosition", "icon", "onOnClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_nr_tag, {
      label: _ctx.severityText,
      "tag-color": _ctx.severityColor
    }, null, 8, ["label", "tag-color"])
  ]))
}